var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.fileSelect}},[_vm._v("上传")]),_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.fileUpload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }